module.exports = __webpack_public_path__ + "static/img/7.4270465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/7.png
// module id = SWQ0
// module chunks = 0